export type Kind =
  | "org"
  | "cloudaccount"
  | "policy"
  | "user"
  | "group"
  | "resource"
  | "task"
  | "permissions"
  | "serviceaccount"
  | "secret"
  | "location"
  | "gvc"
  | "workload"
  | "quota"
  | "identity"
  | "deployment"
  | "event"
  | "domain"
  | "image"
  | "ipset"
  | "resourcepolicy"
  | "agent"
  | "accessreport"
  | "policymembership"
  | "dbcluster"
  | "auditctx"
  | "memcachecluster"
  | "spicedbcluster"
  | "tenant"
  | "mk8s"
  | "command"
  | "imagesummary"
  | "volumeset";

export type CloudAccountProvider = "aws" | "gcp" | "azure" | "ngs";

export type Tags = Record<string, any>;

export interface Link {
  rel: string;
  href: string;
}
export type Links = Link[];

export interface NameValuePair {
  id: string;
  name: string;
  value: string;
}

export interface CreateBase {
  name: string;
  kind: Kind;
  description?: string;
  tags: Tags;
}

export interface Base {
  id: string;
  name: string;
  kind: Kind;
  version: number;
  description: string;
  tags?: Tags; // there are old items in db without tags
  created: string;
  lastModified: string;
  links: Links;
}

export interface List<T> {
  kind: "list";
  itemKind: Kind;
  items: T[];
  links: Link[];
}

export interface ApiError {
  status: number;
  message: string;
  code: string;
  details?: any;
  id: string;
}

export interface OptimisticConcurrency {
  id: string;
  version: number;
}

export interface BaseInput {
  name: string;
  description: string;
  tags: NameValuePair[];
}

export function getDefaultBaseInput(): BaseInput {
  return {
    name: "",
    description: "",
    tags: [],
  };
}
